import React from "react";

import Layout from "../../components/Layout/Layout";
import ResultChart from "./components/Chart/PieChart";
import MoreCalculators from "./components/MoreCalculators";
import TopFunds from "./components/TopFunds";
import { getSelectedCalcData } from "./data/calculatorData";
import FormInput from "./components/FormInput";
import SideColumnCard from "./components/SideColumnCard";

import saveTaxIcon from "../../images/cal-save-tax-icon.svg";
import startSipIcon from "../../images/cal-start-sip-icon.svg";
// import GoldBanner from "../../images/Gold_Banner.jpg";

import {
  calculateReverseSIP,
  lumpsumFutureValue,
  sipFutureValue,
  reccuringDepositFutureValue,
  stepUpSipFutureValue,
  npsFutureValue,
  ssyFutureValue,
  sipFutureValueYearly,
  swpFutureValue
} from "./calcUtilities";
import Result from "./components/Result";
import SEO from "../../components/SEO/SEO";

/*

* Constants
  
*/

const initialState = {
  investmentAmount: 10000,
  returnRate: 6,
  year: 6,
  month: 0,
  stepUp: 10,
  age: 18,
  annuity: 40,
  annuityRate: 6,
  ssyAge: 1,
  ssyReturnRate: 8.3,
  withdrawal: 100,
  calculatorType: null
};

const sideColumnCards = [
  {
    imageUrl: saveTaxIcon,
    heading: "Save taxes upto ₹ 46,800",
    points: ["Highest returns among 80C", "Lowest lock-in period of 3 yrs"],
    btnLabel: " Get Started",
    btnUrl: "https://www.piggy.co.in/tax-saving/"
  },
  {
    imageUrl: startSipIcon,
    heading: "Start an SIP",
    points: ["Save taxes upto ₹45,000", "Highest returns among 80C"],
    btnLabel: " Get Started",
    btnUrl: "https://www.piggy.co.in/search/"
  }
];
/*

* React Class Component
  
*/
class Calculator extends React.Component {
  state = initialState;

  static getDerivedStateFromProps(props, state) {
    const {
      pageContext: { calculatorType }
    } = props;
    if (calculatorType !== state.calculatorType) {
      const selectedCalcData = getSelectedCalcData(calculatorType);
      const ans = selectedCalcData.fieldValues.reduce(
        (accumulator, currentValue) => {
          const field = currentValue["field"];
          return { ...accumulator, [field]: currentValue["default"] };
        },
        {}
      );
      return { ...initialState, ...ans, calculatorType };
    } else {
      return state;
    }
  }

  returnDataToChart() {
    const {
      pageContext: { calculatorType }
    } = this.props;

    if (calculatorType === "reverse-sip-calculator") {
      const { investmentAmount, year, month } = this.state;
      const inMonths = Number(year) * 12 + Number(month);
      return [
        {
          name: "Investment",
          value: Number(this.calculateReturnAmount()) * inMonths,
          nameTwo: "Monthly Amount",
          valueTwo: Number(this.calculateReturnAmount())
        },
        {
          name: "Return",
          value:
            Number(investmentAmount) -
            Number(this.calculateReturnAmount()) * inMonths,
          nameTwo: "Monthly Amount",
          valueTwo: Number(this.calculateReturnAmount())
        }
      ];
    }
    if (calculatorType === "recurring-deposit-calculator") {
      const { investmentAmount, year, month } = this.state;
      const inMonths = Number(year) * 12 + Number(month);
      const returnAmountFinal =
        this.calculateReturnAmount() - investmentAmount * inMonths;
      return [
        {
          name: "Return",
          value: returnAmountFinal,
          nameTwo: "Maturity Amount",
          valueTwo: Number(this.calculateReturnAmount())
        },
        {
          name: "Investment",
          value: Number(investmentAmount * inMonths),
          nameTwo: "Maturity Amount",
          valueTwo: Number(this.calculateReturnAmount())
        }
      ];
    }
    if (calculatorType === "sip-calculator") {
      const { investmentAmount, year, month } = this.state;
      const inMonths = year * 12 + month;
      return [
        {
          name: "Return",
          nameTwo: "Maturity Amount",
          value: Number(
            this.calculateReturnAmount() - investmentAmount * inMonths
          ),
          valueTwo: Number(this.calculateReturnAmount())
        },
        {
          name: "Investment",
          nameTwo: "Maturity Amount",
          value: Number(investmentAmount * inMonths),
          valueTwo: Number(this.calculateReturnAmount())
        }
      ];
    }
    if (calculatorType === "step-up-sip-calculator") {
      const {
        totalAmount,
        investmentAmountFinal
      } = this.calculateReturnAmount();
      return [
        {
          name: "Return",
          value: Number(totalAmount - investmentAmountFinal),
          nameTwo: "Maturity Amount",
          valueTwo: Number(totalAmount)
        },
        {
          name: "Investment",
          value: Number(investmentAmountFinal),
          nameTwo: "Maturity Amount",
          valueTwo: Number(totalAmount)
        }
      ];
    }
    if (calculatorType === "mutual-fund-returns-calculator") {
      const { investmentAmount } = this.state;
      return [
        {
          name: "Return",
          nameTwo: "Maturity Amount",
          value: Number(this.calculateReturnAmount() - investmentAmount),
          valueTwo: Number(this.calculateReturnAmount())
        },
        {
          name: "Investment",
          nameTwo: "Maturity Amount",
          value: Number(investmentAmount),
          valueTwo: Number(this.calculateReturnAmount())
        }
      ];
    }
    if (calculatorType === "fixed-deposit-calculator") {
      const { investmentAmount } = this.state;
      return [
        {
          name: "Return",
          nameTwo: "Maturity Amount",
          value: Number(this.calculateReturnAmount() - investmentAmount),
          valueTwo: Number(this.calculateReturnAmount())
        },
        {
          name: "Investment",
          nameTwo: "Maturity Amount",
          value: Number(investmentAmount),
          valueTwo: Number(this.calculateReturnAmount())
        }
      ];
    }
    if (calculatorType === "nps-calculator") {
      const { compoundedAmount, annuityAmount } = this.calculateReturnAmount();
      return [
        {
          name: "Lumpsum Amount",
          nameTwo: "Total Corpus",
          value:
            Number(compoundedAmount) * Number(1 - this.state.annuity / 100),
          valueTwo: Number(compoundedAmount)
        },
        {
          name: "Annuity Amount",
          nameTwo: "Total Corpus",
          value: Number(compoundedAmount) * Number(this.state.annuity / 100),
          valueTwo: Number(compoundedAmount)
        }
      ];
    }
    if (calculatorType === "sukanya-samriddhi-yojana-calculator") {
      const {
        investmentAmount,
        amountAfterTwentyOneYears
      } = this.calculateReturnAmount();
      return [
        {
          name: "Interest Earned",
          nameTwo: "Maturity Amount",
          value: Number(amountAfterTwentyOneYears - investmentAmount * 14),
          valueTwo: Number(amountAfterTwentyOneYears)
        },
        {
          name: "Investment Amount",
          nameTwo: "Maturity Amount",
          value: Number(investmentAmount * 14),
          valueTwo: Number(amountAfterTwentyOneYears)
        }
      ];
    }
    if (calculatorType === "ppf-calculator") {
      const { investmentAmount, year } = this.state;
      return [
        {
          name: "Return",
          nameTwo: "Maturity Amount",
          value: Number(this.calculateReturnAmount() - investmentAmount * year),
          valueTwo: Number(this.calculateReturnAmount())
        },
        {
          name: "Investment",
          nameTwo: "Maturity Amount",
          value: Number(investmentAmount * year),
          valueTwo: Number(this.calculateReturnAmount())
        }
      ];
    }
    if (calculatorType === "nsc-calculator") {
      const { investmentAmount } = this.state;
      return [
        {
          name: "Return",
          nameTwo: "Maturity Amount",
          value: Number(this.calculateReturnAmount() - investmentAmount),
          valueTwo: Number(this.calculateReturnAmount())
        },
        {
          name: "Investment",
          nameTwo: "Maturity Amount",
          value: Number(investmentAmount),
          valueTwo: Number(this.calculateReturnAmount())
        }
      ];
    }
  }

  returnDurationInString() {
    return this.state.year + "y " + this.state.month + "m";
  }

  calculateReturnAmount() {
    const {
      investmentAmount,
      returnRate,
      year,
      month,
      stepUp,
      age,
      annuity,
      annuityRate,
      withdrawal,
      windowSize
    } = this.state;
    const {
      pageContext: { calculatorType }
    } = this.props;
    let validInvestmentAmount = 0;
    const period = parseInt(year) + month / 12;
    switch (calculatorType) {
      case "fixed-deposit-calculator":
        return Number(lumpsumFutureValue(returnRate, investmentAmount, period));

      case "reverse-sip-calculator":
        return Number(
          calculateReverseSIP(investmentAmount, returnRate, year, month)
        );

      case "mutual-fund-returns-calculator":
        return lumpsumFutureValue(returnRate, investmentAmount, period);

      case "sip-calculator":
        return sipFutureValue(returnRate, investmentAmount, period);

      case "recurring-deposit-calculator":
        return reccuringDepositFutureValue(
          returnRate,
          investmentAmount,
          period
        );

      case "step-up-sip-calculator":
        return stepUpSipFutureValue(
          returnRate,
          investmentAmount,
          period,
          stepUp
        );
      case "nps-calculator":
        return npsFutureValue(
          age,
          investmentAmount,
          returnRate,
          annuity,
          annuityRate
        );
      case "sukanya-samriddhi-yojana-calculator":
        return ssyFutureValue(investmentAmount);

      case "ppf-calculator":
        validInvestmentAmount = investmentAmount;
        if (investmentAmount < 500) validInvestmentAmount = 500;
        else if (investmentAmount > 150000) validInvestmentAmount = 150000;
        return sipFutureValueYearly(returnRate, validInvestmentAmount, period);

      case "nsc-calculator":
        validInvestmentAmount = investmentAmount;
        if (investmentAmount < 100) validInvestmentAmount = 100;
        return lumpsumFutureValue(returnRate, validInvestmentAmount, period);

      case "swp-calculator":
        return swpFutureValue(investmentAmount, returnRate, withdrawal, year);

      default:
    }
  }

  updateFieldValue = fieldType => e => {
    e.persist();
    let fieldVal = e.target.value;

    this.setState(prevState => ({
      ...prevState,
      [fieldType]: fieldVal
    }));
  };

  updateSliderValue = (fieldType, value) => {
    this.setState(prev => ({ ...prev, [fieldType]: value }));
  };


  componentDidMount = () => {
    if (typeof window !== undefined) {
      this.setState(
        { windowSize: window.screen.width }
      );

    }
  }
  render() {
    const {
      pageContext: { calculatorType, topTaxFunds, pageLink }
    } = this.props;
    const selectedCalcData = getSelectedCalcData(calculatorType);
    const { name, description, qA } = selectedCalcData;

    const data = this.returnDataToChart();



    const noChart = calculatorType === "swp-calculator" && this.state.windowSize > 768 ? true : false;

    const {
      investmentAmount,
      returnRate,
      year,
      month,
      steupUp,
      annuity,
      annuityRate,
      age,
      ssyAge,
      investmentDate,
      ssyReturnRate
    } = this.state;

    const duration = this.returnDurationInString();

    return (
      <Layout>
        <SEO link={pageLink} />
        <div className="flex-col wrapper">
          <div className="flex no-wrap space-between container1">
            <div className="shadow-normal border-1 bg-white rounded calcPageWrapper">
              <div style={{ borderBottom: "1px solid #e6e6e6" }}>
                <h1 className="heading-1-bold  spacer_lg selectedCalcName">{name}</h1>
                <p className="para-2 text-justify selectedCalcDesc">{description}</p>
              </div>
              <div className="flex-col wrap rounded bg-white ">
                <div className="w-100 bg-white formInputContainer">
                  <FormInput
                    updateFieldValue={this.updateFieldValue}
                    selectedCalcData={selectedCalcData}
                    currentFieldValue={this.state}
                    updateSliderValue={this.updateSliderValue}
                  />
                </div>
                <div>
                  <Result
                    currentCalcUrl={calculatorType}
                    investmentAmount={investmentAmount}
                    returnAmount={this.calculateReturnAmount()}
                    returnRate={returnRate}
                    year={year}
                    month={month}
                    stepUp={steupUp}
                    duration={duration}
                    annuity={annuity}
                    annuityRate={annuityRate}
                    age={age}
                    ssyAge={ssyAge}
                    investmentDate={investmentDate}
                    ssyReturnRate={ssyReturnRate}
                    limitedWidth={this.props.limitedWidth}
                  />
                </div>
                {!noChart &&
                  <div style={{ width: "100%" }}>
                    <ResultChart currentCalcUrl={calculatorType} data={data} />
                  </div>}
              </div>
            </div>

            <div className="sideColumn">
              {sideColumnCards.map(card => (
                <SideColumnCard {...card} />
              ))}
            </div>
          </div>
          <div className="flex no-wrap space-between container1">
            <div className="flex space-between infoContainer">
              <div>
                {qA.map((faq, ind) => (
                  <div key={ind}>
                    {faq.question && (
                      <h2 className="heading-1 bolder faqQuestion">{faq.question}</h2>
                    )}
                    {faq.subHeading && (
                      <h3 className="heading-3 subHeading">
                        {faq.subHeading}
                      </h3>
                    )}
                    {faq.answer && (
                      Array.isArray(faq.answer) ? (
                        faq.answer.map(ans => {
                          return <p className="para-2 spacer_sm">{ans}</p>;
                        })
                      ) : (
                          <p className="para-2 spacer_sm">{faq.answer}</p>
                        )
                    )}
                  </div>
                ))}
              </div>
            </div>
            <div className="flex-col secondColContainer">
              <MoreCalculators />
              <TopFunds topTaxFunds={topTaxFunds} />
            </div>
          </div>
        </div>
        <style jsx>{`
        .wrapper {
          width: 80%;
          margin: auto;
          padding: 50px 0;
        }.sideColumn {
          width: 28%;
        }
        .calcPageWrapper {
          width: 63%;
          height: fit-content;
          box-sizing: border-box;
          background-color: #ffffff;
          padding: 30px 0 20px;
        }
        .selectedCalcName{
          padding: 0 24px;
        }
        .selectedCalcDesc{
          margin:10px 0 30px;
          padding: 0 24px;
        }
        .formInputContainer{
          border-bottom: 1px solid #e6e6e6;
          box-sizing: border-box;
        }
        .infoContainer{
          box-sizing: border-box;
          width: 63%;
          margin-bottom: 64px;
          margin-top:${noChart ? "-260px" : "24px"};
        }
        .faqQuestion{
          text-decoration:none;
          margin-top:30px;
          margin-bottom:16px;
        }
        .subHeading{
          text-decoration: none;
          margin: 24px 0 8px;        
        }
        .secondColContainer{
          width:28%;
        }
        @media (max-width: 1440px) {
          .wrapper {
            width: 70%;
          }
        }
        @media (max-width: 1024px) {
          .wrapper {
            width: 90%;
          }
        }
        @media screen and (max-width: 768px) {
          .wrapper {
            width: 75%;
            padding: 35px 0;
          }
          .container1 {
            flex-direction: column;
          }
          .sideColumn {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
          }
          .calcPageWrapper {
            width: 100%;
            margin-bottom: 30px;
            padding-bottom: 0;
          }
          .infoContainer {
            width: 100%;
            margin-bottom:24px;
          }
          .secondColContainer {
            width: 100%;
            margin: 24px auto;
          }
        }
        @media screen and (max-width: 600px) {
          .wrapper {
            width: 90%;
          }
          .sideColumn {
            flex-direction: column;
          }
          .selectedCalcName, .selectedCalcDesc{
            padding: 0 16px;
          }
          
        }
        `}</style>
      </Layout >
    );
  }
}

export default Calculator;
